import React from 'react';
import {
  useAchievementsContext,
} from '../../../../../contexts/AchievementsContext/AchievementsContext';
import { StepsForm } from './StepsForm';

export function StepsFormContextWrapper(props) {
  const achievements = useAchievementsContext();

  const globalContext = {
    achievements,
  };

  return (
    <StepsForm
      {...props}
      globalContext={globalContext}
    />
  );
}
